'use strict';

var _require = require('./utils/either'),
    Either = _require.Either;

var fromError = function fromError(type, error) {
  return {
    type: type,
    error: true,
    payload: error
  };
};
var fromSuccess = function fromSuccess(type, value) {
  return {
    type: type,
    payload: value
  };
};

var toEither = function toEither(action) {
  if (action.error === true) {
    return Either.Left(action.payload);
  } else {
    return Either.Right(action.payload);
  }
};

var match = function match(action, patterns) {
  return toEither(action).match(patterns);
};

module.exports.fromError = fromError;
module.exports.fromSuccess = fromSuccess;
module.exports.match = match;


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-serial-effects/dist/action.js
// module id = 77
// module chunks = 0